// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2R2Yi","form":"styles_form__2myXR"};